<script>
import { mapActions, mapGetters } from 'vuex'
import Plyr from 'plyr'
import * as Helper from '@/modules/helper/index'
import DeviceInfo from '@/modules/util/deviceInfo';
export default {
  props: {
    videoId: {
      type: [String, Number],
      default: ''
    },
    videoType: {
      type: String,
      default: 'youtube'
    },
    elementStyle: {
      type: String,
      default: 'medium'
    }
  },
  data() {
    return {
      mediaPlayer: null
    }
  },
  computed: {
    ...mapGetters([
      'VideoPlayerArray',
      'resource'
    ]),
    videoStyle() {
      let Height = Helper.calculateHeight(this.elementStyle)
      return {
        'height': `${Height}px`
      }
    },
    dataType() {
      let obj = 'youtube' // default
      // if (this.videoType === 'video/mp4') { obj = 'video/mp4' }
      // if (this.videoType === 'video/webm') { obj = 'video/webm' }
      if (this.videoType === 'youtube') { obj = 'youtube' }
      if (this.videoType === 'vimeo') { obj = 'vimeo' }
      return obj
    },
    getPlayers() {
      return this.VideoPlayerArray.filter(player => player.Id !== this.playerId)
    },
    playerId() {
      return Helper.getRandomInt()
    },
    noVedioShow() {
      return this.videoId === 'http://' || this.videoId === 'https://' || Helper.IsNullOrEmpty(this.videoId)
    }
  },
  watch: {
    videoId: function(value) {
      if (this.mediaPlayer) {
        this.mediaPlayer.source = {
            type: 'video',
            sources: [
                {
                  src: value,
                  provider: this.videoType,
                },
            ],
        }
      }
    },
    videoType: function(value) {
      if (this.mediaPlayer) {
        this.mediaPlayer.source = {
            type: 'video',
            sources: [
                {
                  src: this.videoId,
                  provider: value,
                },
            ],
        }
      }
    }
   },
  mounted() {
    this.createplayer()
    this.mediaPlayer.on('play', this.onPlayerPlay)
  },
  beforeDestroy() {
    if (this.mediaPlayer) {
      try {
        this.mediaPlayer.destroy()
      } catch (e) {
      }
    }
    if (this.getPlayers) {
      this.updateVideoPlayerArray(this.getPlayers)
    }
  },
  methods: {
    ...mapActions([
      'updateVideoPlayerArray'
    ]),
    createplayer() {
      this.mediaPlayer = new Plyr(this.$refs.plry, {
        controls: ["play", "progress", "current-time", "mute", "volume", "captions", "fullscreen"],
        hideControls: false,
        autoplay: false
      });
    },
    onClickVideoWrapper () {
      if (Helper.IsDevSim()) {
        let modalOptions = {
            title: this.resource.warningTitle,
            text: this.resource.warningMessage,
            buttonText: this.resource.closeBtn,
            downloadbuttonText: DeviceInfo.isAndroid ? this.resource.AndroidDownload : this.resource.AppleDownload,
            $f7: this.$f7
          }
          this.$showModal(modalOptions)
      }
    },
    onPlayerPlay() {
      this.getPlayers.forEach((playerobj) => {
        let player = playerobj.player
        if (player.playing) {
          player.pause()
        }
      })
      let playerExist = this.VideoPlayerArray.find(player => player.Id === this.playerId)
      if (!playerExist) {
        let ply = this.getPlayers
        ply.push({Id: this.playerId, player: this.mediaPlayer})
        this.updateVideoPlayerArray(ply)
      }
    }
  }
}
</script>
<template>
  <div class="video-wrapper" @click="onClickVideoWrapper">
    <div :class="{'hide-player' : noVedioShow}">
      <template v-if="dataType === 'youtube'">
        <div ref="plry"
          :data-plyr-provider="dataType"
          :data-plyr-embed-id="videoId"
          @play="onPlayerPlay"
          >
        </div>
      </template>
      <template v-else-if="dataType === 'vimeo'">
        <div ref="plry"
          :data-plyr-provider="dataType"
          :data-plyr-embed-id="videoId"
          @play="onPlayerPlay"
          >
        </div>
      </template>
    </div>
    <div class="cover-background no-video" :class="{'hide-default-video' : !noVedioShow}" :style="videoStyle">
    </div>
  </div>
</template>
<style scoped>
  .video-wrapper {
    padding: 10px 0px!important;
  }
  .hide-player {
    display: none;
  }
  .hide-default-video {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Video.vue